export default {
  CHANGE: "CHANGE",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  REFRESH: "REFRESH",
  REFRESH_BAR: "REFRESH_BAR"
};
